import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import FixedValueForm from "../types/FixedValueForm";

export const CustomerMarketingForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const options = [
    { label: "Sim", value: 63 },
    { label: "Não", value: 0 },
  ];

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CustomerMarketing}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <FixedValueForm
        node={node}
        options={options}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
